import styles from './podcast.module.sass'

import Button from '../basic/button'

function Podcast(props) {
	let fields = props.fields

	return <div className={styles.podcast}>
		<h1>{fields.title}</h1>
		<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
		<Button fields={{button: {url: fields.podcast_url, title: 'Go to podcast', target: '_blank'}}} className={styles.button}></Button>
	</div>
}

export default Podcast